import * as React from 'react'
import { Modal, ModalProps, Button } from 'react-bootstrap'

export const ModalHint = ({ children, title, ...props }: React.PropsWithChildren<ModalProps & { title: string }>) => {
  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered variant="dark">
      <Modal.Header className="text-white" closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button onClick={props.onHide}>Schließen</Button>
      </Modal.Footer>
    </Modal>
  )
}
